<div class="cont">

    <ngc-ann-content-viewer [format]="claim?.internalFormat"
                            [documentUrl]="documentUrl"
                            [isHtmlDocumentLoading$]="isHtmlDocumentLoading$"
    >
    </ngc-ann-content-viewer>

    <div *ngIf="!(isHtmlDocumentLoading$ | async) && claim" style="margin-bottom: 15px;">
        <strong>This document was last modified on {{claim?.regDate | datePlusGMTPipe: 'medium'}}</strong>
    </div>

</div>
